import {ChangeDetectorRef, Component, HostListener, Input, OnInit} from '@angular/core';
import {DataService} from '../services/data.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {SpeedDialItemModel} from '@syncfusion/ej2-angular-buttons';
import {IndexedDbData} from '../models/indexedDB-model';
import {LocalStorageService} from 'src/app/local-storage.service';
import {MatDialog} from '@angular/material/dialog';
import {Employees} from '../models/employees-model';
import {UserAuthenticationService} from '../../services/user-authentication.service';
import {BenutzerModels} from '../../models/benutzer-models';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() lockIcon = '';
    @Input() showDate = false;
    public deferredPrompt: any;
    public checkForDevice!: string;
    public showVinavon = false;
    public showServiceApp = false;
    public menuItems: SpeedDialItemModel[] = [];
    public IndexedDbData!: IndexedDbData;
    public userPermissions!: Employees;
    public showTimeApp = false;
    protected chosenDate = '';


    constructor(private cd: ChangeDetectorRef,
                private userAuthService: UserAuthenticationService,
                private dataService: DataService,
                private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer,
                private localStorage: LocalStorageService,
                public dialog: MatDialog) {
        this.registerIcons();
    }

    ngOnInit(): void {
        this.loadSpeedMenu();
    }

    @HostListener('window:beforeinstallprompt', ['$event']) onbeforeinstallprompt(event: any): void {
        this.deferredPrompt = event;
        this.cd.detectChanges();
    }

    @HostListener('window:appinstalled', ['$event']) onappinstalled(event: any): void {
        this.deferredPrompt = null;
    }

    findUserPermissions(): void {
        this.userPermissions = this.IndexedDbData.allEmployees.find((el) => el.employeeID === this.userAuthService.getCurrentAuthenticatedUser()?.employeeID)!;
    }


    checkDevice(): string {
        const ua = navigator.userAgent;
        if (/android/i.test(ua)) {
            return 'Android';
        } else if (
            /iPad|iPhone|iPod/.test(ua) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        ) {
            return 'iOS';
        }
        return 'Other';
    }

    logout(): void {
        this.userAuthService.logoutUser('/login');
    }

    private async getAllEmployeesWebCall(): Promise<void> {
        // Die Mitarbeiter können nur abgeholt werden, wenn eine EmployeeID vorhanden ist
        if (this.userAuthService.getCurrentAuthenticatedUser()) {
            const res = await this.dataService.getAllEmployee();
            if (!res) {
                return;
            }
            this.IndexedDbData.allEmployees = res;
            await this.updateUserPermissions();
            this.findUserPermissions();
        }
    }

    private async updateUserPermissions(): Promise<void> {
        if (!this.userPermissions) {
            await this.getAllEmployeesWebCall();
        } else {
            this.findUserPermissions();
        }
    }

    private async loadSpeedMenu(): Promise<void> {
        this.showVinavon = await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CNavigatorMobile);
        this.showServiceApp = await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CServiceApp);
        this.showTimeApp = await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CMobileTime);

        if (this.showDate) {
            this.chosenDate = this.dataService.getChosenDateFormatted();
        }

        this.checkForDevice = this.checkDevice();
    }

    private registerIcons(): void {
        this.matIconRegistry
            .addSvgIcon('ss-logo', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/swiss-soft-logo_zentriert_black.svg'))
            .addSvgIcon('arrow-back', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/svg_images/arrow-back.svg'))
            .addSvgIcon('arrow-forward', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/svg_images/arrow-forward.svg'));

    }
}
